export const routes = {
  HOME_PAGE: "/",
  ABOUT_PAGE: "/aboutPage",
  CONTACT_PAGE: "/contactPage",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  REFUND_POLICY: "/refund-policy",
  RETURN_POLICY: "/return-policy",
  DELIVERY_POLICY: "/delivery-policy",
  DEFAULT: "",
  ADMIN: "/admin",
  ADMIN_PAGE: "/adminPage",
  ADMIN_LOGIN: "/admin/login",
  DASHBOARD: "/admin/dashboard",
  PPOD_MANAGEMENT: "/admin/ppodmanagement",
  PUSER_MANAGEMENT: "/admin/pusermanagement",
  PUSER_INFO: "/admin/pusermanagement/puserInfo",
  PUSERS: "/pusers",
  PSIGN_UP: "/pusers/psignup",
  PUSER_LOGIN: "/pusers/plogin",
  FORGOT_PASSCODE: "/pusers/forgotPasscode",
  PUSER_TRANSACTION: "/pusers/puserTransaction",
  PUSER_PROFILE: "/pusers/puserInfo",
  LIVE_STREAMING: "/pusers/livestreaming",
  HELP: "/pusers/help",
  VISITORS: "/pusers/visitors",
  GUARD_LOGIN: "/guard/login",
  GUARD_DASHBOARD: "/guard/dashboard",
  GUARD: "/guard",
};
